import { useMemo } from 'react';
import { buildBreadcrumbs } from '../../../config/navigation/breadcrumbs';

/**
 * Breadcrumb trail for the business function (account) detail page.
 * Current business function only — no hub listing link.
 */
export default function useAccountBreadcrumbs(accountName) {
  return useMemo(
    () => buildBreadcrumbs([
      { label: accountName || 'Account' },
    ]),
    [accountName]
  );
}
